import { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
import { PAGE_LIMITS, modulePermissions } from "../../../constants";
import Table from "../../../components/tables/table";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { locationFieldData } from "../../../data/TableData";
import * as XLSX from 'xlsx';


const MODULE_URI = "/master/locationlisting";
export default function LocationListing() {
 
  const navigate = useNavigate();


  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(PAGE_LIMITS[0]);
  const [totalCount, setTotalCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [LocationsData, setLocationsData] = useState([]);
  const [addUpdate, setAddUpdate] = useState(false);
  const [locDownFlag, setLocationDownFlag] = useState(false);

  
  const [resData, error, loading, axiosFetch] = useAxios();
    const [resStatusData, errorStatus, loadingStatus, axiosFetchStatus] = useAxios();
    const [LocExcData, errorExcel, loadingExcel, axiosExcLocSlot] = useAxios();
  
  const FETCH_API_URL = "master/getLocationData?";
  const SUBMIT_EXP_BOOK_SLOT = "master/getLocationExcel?";

  const getData = (url) => {
    axiosFetch({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
  useEffect(() => {
    getData(`${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`)

  },[FETCH_API_URL,loadingStatus, search, page, limit])
  

//   useEffect(() => {
//     if (addEditCustomerToast === "edit") {
//       toast.success("Customer updated successfully", {
//         position: toast.POSITION.TOP_RIGHT,
//       });
//     } else if (addEditCustomerToast === "add") {
//       toast.success("Customer Added successfully", {
//         position: toast.POSITION.TOP_RIGHT,
//       });
//     }
//   }, [addEditCustomerToast]);

//   const getData = (url) => {
//     axiosFetch({
//       axiosInstance: axiosInstance,
//       url: url,
//       method: "GET",
//     });
//   };

  const handleSearchFieldChange = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const handleLimitChange = (e) => {
      setLimit(e.target.value);
  };
console.log("resData?=",resData?.[0]?.LocationsData)
  useEffect(() => {
    if (resData?.[0]?.success !== false && resData.length > 0) {
     
      setTotalCount(resData?.[0]?.totalCount);
      setLocationsData(resData?.[0]?.LocationsData);
      const tempData = resData?.[0]?.LocationsDataAll.map((item) => {
        return {
                _id: item._id,
                locationName: item.locationName,
                address: item.address,
                stateName: item.stateName,
                districtName: item.districtName,
                pincode: item.pincode,
                status: item.status,
        };
      });
      setTableData(tempData);
    } else {
      if( resData?.[0]?.success === false) {
        toast.error("No data found", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setLocationsData([]);
      setTableData([]);
      setTotalCount(0);
    }
  }, [resData]);

   function navigateToEditPage(rowIndex) {
      if (rowIndex >= 0) {
        const currItem = tableData[rowIndex];
  
        navigate(`${MODULE_URI}/add/${currItem?._id}`);
      } else {
        // navigate(MODULE_URI);
      }
    }
     const handleStatus = async (rId, status,id) => {
      
        await axiosFetchStatus({
          axiosInstance: axiosInstance,
          url: `master/updateLocationStatusData/${rId}`,
          method: "POST",
          requestConfig: {
            data: {
              status,
            },
          },
        });
        setAddUpdate(true);
      };

      useEffect(() => {
        if (addUpdate&& !resStatusData?.[0]?.['success']) {
          toast.error(
            `Your status could not be Updated!!error:${errorStatus}`,
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 50,
            }
          );
          setAddUpdate(false);
        } else if (addUpdate&& resStatusData?.[0]?.['success']) {
          toast.info(
            `Your status is Updated!!`,
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 50,

            }
          );
          setAddUpdate(false);
        }
      },[loadingStatus])

      
           useEffect(() => {
                
                  if(LocationsData.length>0 && locDownFlag){
                    console.log("LocationsData=",LocationsData)
                    const toTitleCase = (str) => {
                      return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
                        return match.toUpperCase();
                      });
                    };
                    let fileName = `LocationsExcelData.xlsx`;
                  
                    const jsonData = LocationsData.map((item) => {
                  
                         
                  
                      return {
                       
                        Location_Name: item.locationName,
                        Address: item.address,
                        State_Name: item.stateName,
                        District_Name: item.districtName,
                        Pincode: item.pincode,
                       
                  
                      };
                    });
                   
                  
                    const worksheet = XLSX.utils.json_to_sheet(jsonData);
                      const workbook = XLSX.utils.book_new();
                      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                      XLSX.writeFile(workbook, fileName);
                  
                    
                        toast.info(
                         "Locations Data Downloaded Successfully",
                          {
                            position: toast.POSITION.TOP_RIGHT,
                          }
                        );
                       
                  
                     
                  
          
                } else if(LocationsData.length !==0 && locDownFlag){
                  toast.error(
                    "No data found to download",
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );
          
                }
                setLocationDownFlag(false);

          
          
          
              },[locDownFlag])


  return (
    <>
    <div className="card min-height-100">
      <div className="pump-report-top">
        <h2 className="text-navyBlue">Location List</h2>
        <ToastContainer />

        <div className="btn-wrapper">
          {modulePermissions?.canAdd && (
            <Link
              to={`${MODULE_URI}/add`}
              className="btn btn-sm btn-blue rounded-10"
            >
              Add Location
            </Link>
          )}
           <button type="button" className="btn btn-sm btn-green rounded-10" onClick = {() =>  setLocationDownFlag(true)}>
              Download Excel
            </button>

          {/* {modulePermissions.canDownload && (
            <button className="btn btn-sm btn-green rounded-10">
              Download Data
            </button>
          )} */}
        </div>
      </div>

      {/* {loading && <Loader />} */}

      {/* {!loading && error && (
        <div className="label label-block label-red-bg rounded-10 mt-10 mb-10">
          {error || "Something went wrong!!"}
        </div>
      )} */}

     

      <div className="pump-search">
        <span className="text-gray">
          {" "}
          Show Entries
          <select
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            onChange={handleLimitChange}
          >
            {PAGE_LIMITS.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
        </span>

        <span>
          {" "}
          <input
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            placeholder="Search"
            onKeyDown={handleSearchFieldChange}
          />
        </span>
      </div>
      <div className="company-table ">
        <Table
          tableColumns={locationFieldData}
          tableData={tableData}
          tableSettings={{
            page,
            pageSize: limit,
            totalCount,
          }}
          action={true}
          modulePermissions={modulePermissions}
          handleStatus={handleStatus}
          handleEdit={navigateToEditPage}
          handlePage={setPage}
          handleCustAssetFlag = {true}
        />
      </div>
    </div>
    </>
    
  );
}
